// ═══════════════════════════════════════
// TRANSPOSE — Transposition ABC via abc-notation-transposition
// ═══════════════════════════════════════

import { transposeABC } from 'abc-notation-transposition';
import {
    getAbcContent, parseAbcDocument,
    setHeadersContent, setVoiceHeaderContent, setVoiceContent,
    highlightAll
} from './editor.js';
import { render } from './renderer.js';
import { trackEvent } from './analytics.js';
import { updateVoiceFromForm } from './header-form.js';

export function transposeAbc(semitones) {
    const text = getAbcContent();

    let transposed;
    try {
        transposed = transposeABC(text, semitones);
    } catch (e) {
        console.error('[transpose] Erreur:', e);
        return;
    }

    const { global, voiceHeaders, voices } = parseAbcDocument(transposed);
    setHeadersContent(global);
    voiceHeaders.forEach((h, i) => {
        setVoiceHeaderContent(i, h);
        // Recalcule les directives contextuelles (%%bagpipes, stem=up…)
        // car la tonalité a pu changer
        updateVoiceFromForm(i);
    });
    voices.forEach((v, i) => setVoiceContent(i, v));

    highlightAll();
    render();
}

export function initTransposeButtons() {
    document.getElementById('transpose-down-btn')
        ?.addEventListener('click', () => {
            transposeAbc(-1);
            trackEvent('Editeur', 'transpose', 'down');
        });
    document.getElementById('transpose-up-btn')
        ?.addEventListener('click', () => {
            transposeAbc(1);
            trackEvent('Editeur', 'transpose', 'up');
        });
}